<div class="spinner-container" *ngIf="loading">
    <mat-spinner class="content-box"></mat-spinner>
</div>
<div *ngIf="!isSubcomponent" class="filter-container" autofocus>
    <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" [(ngModel)]="resetFilter"
            placeholder="{{'common.filter' | translate}}">
    </mat-form-field>
    <mat-form-field>
        <mat-select placeholder="{{'manageTexts.status' | translate}}" [(ngModel)]="certFilterStatus"
            [value]="certFilterStatus" (selectionChange)="loadFilteredCertificates()">
            <mat-option *ngFor="let s of statusLables" [value]="s">
                {{getCertificateStatusText(s) | translate}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<p *ngIf="!loading && emptyCertificates">{{'manageTexts.noCertificates' | translate}}</p>
<div id="wrapper" *ngIf="!loading && !emptyCertificates">
    <div *ngIf="lang" class="mat-elevation-z8">
        <mat-table *ngIf="dataSource" [dataSource]="dataSource" matSort>

            <!-- Статус -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'manageTexts.status' |
                translate}} </mat-header-cell>
                <mat-cell *matCellDef="let row" matTooltip="{{statusIcon(row.status)?.tooltip | translate}}">
                    <cqes-icon [icon]="statusIcon(row.status)?.icon" [iconClass]="statusIcon(row.status)?.colorClass">
                    </cqes-icon>
                </mat-cell>
            </ng-container>


            <!-- Име -->
            <ng-container matColumnDef="owner">
                <mat-header-cell *matHeaderCellDef mat-sort-header class=" d-none d-md-flex custom-header"> {{'manageTexts.owner' |
            translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="custom-header flex-column align-items-start d-none d-md-flex"
                    matTooltip="{{getCertOwner(row)}}" class="holder-cell">
                    <span class="owner-txt">{{getCertOwner(row)}}</span>
                    <div class="owner-container">
                        {{'manageTexts.commonName' |
                    translate}}: <span class="owner-txt">{{getCommonName(row)}}</span>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Common Name -->
            <!-- <ng-container matColumnDef="commonName">
            <mat-header-cell class="d-none d-lg-flex" *matHeaderCellDef mat-sort-header> {{'manageTexts.commonName' |
                translate}} </mat-header-cell>
            <mat-cell class="d-none d-lg-flex" *matCellDef="let row" id="common-name"
                matTooltip="{{row.commonName | translate}}"><span>{{row.commonName}}</span></mat-cell>
        </ng-container> -->

            <!-- email
        <ng-container matColumnDef="email">
            <mat-header-cell class="d-none d-lg-flex" *matHeaderCellDef mat-sort-header> {{'manageTexts.email' |
                translate}} </mat-header-cell>
            <mat-cell class="d-none d-lg-flex" *matCellDef="let row">{{row.email}}</mat-cell>
        </ng-container> -->

            <!-- Валидност -->
            <ng-container matColumnDef="validTo">
                <mat-header-cell class="d-none d-md-flex" *matHeaderCellDef mat-sort-header>
                    {{'manageTexts.validTo' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" class="d-none d-md-flex">{{row.validTo | date: dateFormat}}</mat-cell>
            </ng-container>

            <!-- Сериен номер -->
            <ng-container matColumnDef="serialNo">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'manageTexts.serial' |
                translate}} </mat-header-cell>
                <mat-cell *matCellDef="let row" id="serialNumber" matTooltip="{{row.serialNo}}">
                    <span>{{row.serialNo}}</span></mat-cell>
            </ng-container>

            <!--Псевдоним-->
            <ng-container matColumnDef="alias">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    matTooltip="{{'manageTexts.tooltips.changeAlias' | translate}}"> {{'manageTexts.alias' |
                translate}} </mat-header-cell>
                <mat-cell *matCellDef="let row" id="alias" matTooltip="{{row.alias}}"><span>{{row.alias}}</span>
                </mat-cell>
            </ng-container>

            <!-- Действия -->
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef translate id="actions" class="tac actions"> {{'manageTexts.actions' |
                translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row" translate class="actions"
                    [style.visibility]="isPendingHold(row.status) ? 'hidden' : 'visible'">
                    <span [matMenuTriggerFor]="actionsMenu">
                        <button mat-icon-button color="primary">
                            <cqes-icon icon="menu"></cqes-icon>
                        </button>
                    </span>
                    <mat-menu #actionsMenu [overlapTrigger]="false" class="nav-responsive-overlay">
                        <div class="actions-icons-wrapper">
                            <div class="icons-inner-wrapper">
                                <button *ngIf="isHolded(row.status)"
                                     mat-menu-item
                                    color="primary" matTooltip="{{'manageTexts.tooltips.activate' | translate}}"
                                    (click)="onRestore(row)">
                                    <cqes-icon icon="touch_app"></cqes-icon>
                                    {{'manageTexts.inMenuRestore' | translate}}
                                </button>
                                <button
                                    [hidden]="isPendingHold(row.status) ||  isExpired(row.status) || isRevoked(row.status)"
                                    *ngIf="!isSubcomponent" mat-menu-item color="primary"
                                    matTooltip="{{'manageTexts.tooltips.showDevices' | translate}}"
                                    (click)="showDevices(row)">
                                    <cqes-icon icon="smartphone"></cqes-icon>
                                    {{'manageTexts.inMenushowDevices' | translate}}
                                </button>
                                <button [hidden]="!isValid(row.status)" mat-menu-item color="primary"
                                    matTooltip="{{'manageTexts.tooltips.hold' | translate}}" (click)="onHold(row)">
                                    <cqes-icon icon="pan_tool"></cqes-icon>
                                    {{'manageTexts.inMenuTempFreeze' | translate}}
                                </button>
                                <div matTooltip="{{'manageTexts.tooltips.deviceLimit' | translate}}"
                                    [matTooltipDisabled]="!isLimitReach(row)">
                                    <button mat-menu-item [disabled]="isLimitReach(row)" color="primary"
                                        matTooltip="{{'manageTexts.tooltips.addDevice' | translate}}"
                                        [matTooltipDisabled]="isLimitReach(row)"
                                        (click)="onAddDevice(row)"
                                        [hidden]="!isValid(row.status)">
                                        <cqes-icon icon="swap_horiz"></cqes-icon>
                                        {{'manageTexts.inMenuAddDevices' | translate}}
                                    </button>
                                </div>
                            </div>
                            <div class="icons-inner-wrapper">
                                <button mat-menu-item color="primary"
                                    matTooltip="{{'manageTexts.tooltips.shop' | translate}}" (click)="buyPack(row)"
                                    *ngIf="!isEmergencyLogin"
                                    [hidden]="!isValid(row.status) || isInfinite(row) || areOrdersHidden()">
                                    <cqes-icon icon="store"></cqes-icon>
                                    {{'manageTexts.inMenuBuySignings' | translate}}
                                </button>
                                <button mat-menu-item color="primary"
                                    matTooltip="{{'manageTexts.tooltips.download' | translate}}"
                                    (click)="onDownloadCert(row)" *ngIf="!isEmergencyLogin">
                                    <cqes-icon icon="file_download"></cqes-icon>
                                    {{'manageTexts.inMenuDownloadPkey' | translate}}
                                </button>
                                <button [hidden]="isSubcomponent" mat-menu-item color="primary"
                                    matTooltip="{{'manageTexts.tooltips.showDetails' | translate}}"
                                    (click)="openCertificateDetailsDialog(row)">
                                    <cqes-icon icon="info_outline"></cqes-icon>
                                    {{'manageTexts.inMenuInfo' | translate}}
                                </button>
                            </div>
                        </div>
                    </mat-menu>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
</div>